import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {observer} from "mobx-react";
import {BreadcrumbsItem} from "./breadcrumbs.item";
import classNames from "classnames";
import styles from "./breadcrumbs.module.scss";
import {BreadcrumbsDots} from "./breadcrumbs.dots";
import {BreadcrumbsArrow} from "./breadcrumbs.arrow";

class BreadcrumbsCollapsedListProps extends BaseProps {}

export const BreadcrumbsCollapsedList = observer(({controller}: BreadcrumbsCollapsedListProps) => {
  const {state} = controller;
  const {breadcrumbsList} = state;

  const firstItemProps = {
    controller,
    item: breadcrumbsList.first()
  }

  const lastItemProps = {
    controller,
    item: breadcrumbsList.last(),
    isLast: true
  }

  return (
    <>
      <BreadcrumbsItem {...firstItemProps}/>
      <div className={classNames(styles.item)}>
        <BreadcrumbsDots controller={controller}/>
        <BreadcrumbsArrow controller={controller}/>
      </div>
      <BreadcrumbsItem {...lastItemProps}/>
    </>
   )
});
